import { useCountDown } from '../hooks/countdown'
import { Box, SlideFade, Stack, Text, useColorModeValue } from '@chakra-ui/react'
import { usePrevious } from '@uidotdev/usehooks'
import { useEffect, useState } from 'react'

function NumberSlot({ value, label }: { value: number; label: string }) {
  const [fade, setFade] = useState(false)
  const prevCount = usePrevious(value)

  useEffect(() => {
    if (prevCount !== undefined && value !== prevCount) {
      setFade(false)
      setTimeout(() => {
        setFade(true)
      }, 100)
    }
  }, [value, prevCount])

  return (
    <Stack width={30} direction={'column'} spacing={0} align={'center'}>
      <SlideFade offsetY="10px" in={fade}>
        <Box
          rounded={'sm'}
          bg={useColorModeValue('primary.base', 'rgba(155, 81, 244, 0.3)')}
          width={8}
          height={7}
          color={'white'}
        >
          <Text fontWeight={500} align={'center'}>
            {value}
          </Text>
        </Box>
      </SlideFade>
      <Text fontWeight={300} align={'center'}>
        {label}
      </Text>
    </Stack>
  )
}

export default function Countdown({ targetDate }: { targetDate: Date }) {
  const [days, hours, minutes, seconds] = useCountDown(targetDate)

  return (
    <Stack direction="row" spacing={6}>
      <NumberSlot value={days} label={'days'} />
      <NumberSlot value={hours} label={'hours'} />
      <NumberSlot value={minutes} label={'mins'} />
      <NumberSlot value={seconds} label={'secs'} />
    </Stack>
    // <span className="countdown font-mono text-2xl">
    //     <span>{hours}</span>h
    //     <span>{minutes}</span>m
    //     <span>{seconds}</span>s
    // </span>
  )
}
